// extracted by mini-css-extract-plugin
export default {"breadcrumbsWrapper":"BreadcrumbsWrapper__breadcrumbsWrapper--y1w7B","breadcrumbs":"BreadcrumbsWrapper__breadcrumbs--1Lazr"};